import { createUseStyles } from '@glu/theming';

const styles = ({
  palette: {
    colors: { apple, flamingo, lochmara, mineShaft },
    error
  },
  shadows,
  spacing: { unit },
  typography: { fontSize, fontWeightHeavy, h2 }
}) => ({
  intro: {
    opacity: '0',
    transition: 'all 500ms',
    '& h1': {
      paddingLeft: '60px'
    }
  },
  loaded: {
    opacity: '1'
  },
  wrapper: {
    maxWidth: '650px',
    margin: '0 auto',
    '& h2': {
      fontWeight: h2.fontWeight
    },
    '& h3': {
      marginTop: '20px',
      fontSize,
      fontWeight: fontWeightHeavy
    }
  },
  fullWidth: {
    marginBottom: '10px',
    '& > label': {
      width: '100%'
    }
  },
  contactDetail: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    '@media (max-width: 650px)': {
      flexDirection: 'column',
      alignItems: 'end',
      '& > div': {
        padding: '10px 0'
      }
    }
  },
  contactPoint: {
    display: 'flex',
    flexDirection: 'column'
  },
  contactPointFields: {
    display: 'flex',
    alignItems: 'flex-start',
    '& > *': {
      flex: '1'
    }
  },
  alignDropdown: {
    '& > label > button:disabled': {
      background: 'white'
    }
  },
  alignInput: {
    marginTop: '-4px'
  },
  marginRight: {
    marginRight: '15px'
  },
  hideDropdownArrow: {
    '& > label > button > div > svg': {
      display: 'none'
    }
  },
  validationChecks: {
    listStyle: 'none',
    padding: '0',
    '& > li > span': {
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      '& > div > svg': {
        height: '12px'
      }
    }
  },
  boldText: {
    fontWeight: 'bold'
  },
  errorText: {
    color: error.dark,
    fontSize: 1.5 * unit,
    height: 2.5 * unit
  },
  closeIcon: {
    position: 'absolute',
    top: 10,
    right: 10,
    cursor: 'pointer',
    border: 0,
    '& svg': {
      fill: mineShaft,
      width: 12,
      height: 12
    }
  },
  emailIconContainer: {
    minWidth: 125
  },
  emailIcon: {
    display: 'flex',
    columnGap: 10,
    '& svg': {
      fill: mineShaft,
      width: 22,
      height: 22
    }
  },
  flexpand: {
    flex: 1
  },
  defaultIndicator: {
    margin: 0,
    textAlign: 'right',
    color: apple,
    fontFamily: 'Roboto Condensed'
  },
  card: {
    padding: [15, 20],
    borderRadius: 4,
    boxShadow: `${unit / 8}px ${unit / 8}px ${unit / 2}px ${unit / 4}px ${shadows.normal}`,
    position: 'relative'
  },
  verticalGap: {
    marginBottom: 30
  },
  extendedSecurityWarning: {
    display: 'flex',
    alignItems: 'center'
  },
  triangleIcon: {
    '& svg': {
      fill: '#f15a24',
      marginRight: '10px'
    }
  },
  zeroMargin: {
    margin: 0
  },
  addContactButton: {
    display: 'flex',
    alignItems: 'center',
    columnGap: 10
  },
  circlePlusIcon: {
    '& svg': {
      fill: lochmara
    }
  },
  makeDefaultLabel: {
    marginTop: 3.75 * unit,
    flex: 'none'
  },
  makeDefaultText: {
    paddingLeft: 10,
    textAlign: 'right',
    fontFamily: 'Roboto Condensed',
    margin: 0,
    userSelect: 'none'
  },
  readyForDefault: {
    color: apple
  },
  invalidCode: {
    color: flamingo
  },
  enterCodeText: {
    marginTop: 2.75 * unit
  },
  formSectionBtnContainer: {
    paddingTop: 2 * unit,
    display: 'flex',
    alignItems: 'center',
    columnGap: 10
  },
  voiceExtension: {
    position: 'relative',
    '& :nth-child(2)': {
      position: 'absolute',
      right: 0
    }
  },
  challengeManagerContainer: {
    position: 'relative',
    zIndex: 9999
  },
  loginFlowContainer: {
    padding: 60
  },
  commonAlert: {
    width: '80%',
    maxWidth: 650,
    margin: '0 auto 25px auto'
  },
  criteriaList: {
    fontSize: '90%',
    paddingLeft: 15
  },
  checkboxText: {
    paddingLeft: 10
  }
});

export default createUseStyles(styles);
